interface EstadoVazioProps {
  icone?: string;
  titulo: string;
  descricao?: string;
  acaoRotulo?: string;
  aoClicarAcao?: () => void;
}

export default function EstadoVazio({
  icone = 'ri-inbox-2-line',
  titulo,
  descricao,
  acaoRotulo,
  aoClicarAcao,
}: EstadoVazioProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-3xl border border-secondary-100 bg-white px-6 py-12 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-200/60 text-primary-600">
        <i className={`${icone} text-2xl`} />
      </span>
      <p className="mt-4 text-base font-semibold text-foreground-950">{titulo}</p>
      {descricao && <p className="mt-1 max-w-sm text-sm text-foreground-600">{descricao}</p>}
      {acaoRotulo && aoClicarAcao && (
        <button
          type="button"
          onClick={aoClicarAcao}
          className="mt-5 cursor-pointer whitespace-nowrap rounded-2xl bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
        >
          {acaoRotulo}
        </button>
      )}
    </div>
  );
}